import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';
import WorkoutDiscussion from 'src/sections/home/workout-discussion';

// ----------------------------------------------------------------------

const metadata = { title: `Workout Discussion |  ${CONFIG.appName}` };

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <WorkoutDiscussion />
    </>
  );
}
